import { gql } from '@apollo/client'

export const CREATE_OR_UPDATE_UPC_TO_CATEGORY = gql`
  mutation CreateOrUpdateUPCToCategory(
    $input: CreateOrUpdateUPCToCategoryInput!
  ) {
    createOrUpdateUpcToCategory(input: $input) {
      upcToCategory {
        upc
        category {
          category
          id
        }
      }
    }
  }
`
